import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {} from "./plugins/filters";
import Parse from "./plugins/parseConnect";
import axios from "axios";
import VueCarousel from "vue-carousel";

import vClickOutside from "v-click-outside";
import VueMeta from "vue-meta";

import VueLazyload from "vue-lazyload";
import Vuelidate from "vuelidate";
import GAuth from "vue-google-oauth2";

const gauthOption = {
  clientId:
    "828710218585-kt7sbieb64c86709d58i6fnd5gu5aun8.apps.googleusercontent.com",
  scope: "profile email",
  prompt: "select_account",
};
Vue.use(GAuth, gauthOption);

// Vue.use(GoogleLogin);
Vue.use(Vuelidate);
Vue.use(VueLazyload);
Vue.use(vClickOutside);
Vue.use(VueCarousel);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

Vue.prototype.$http = axios;

import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faUser,
  faSearch,
  faChevronDown,
  faPlus,
  faHeart,
  faCheckCircle,
  faCheck,
  faEye,
  faPlusCircle,
  faShareAlt,
  faThumbsUp,
  faThumbsDown,
  faChevronRight,
  faChevronLeft,
  faTimes,
  faTimesCircle,
  faEnvelope,
  faLock,
  faBars,
  faFilm,
  faGlobe,
  faSpinner,
  faSignOutAlt,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faTwitter,
  faApple,
  faGoogle,
  faInstagram,
  faImdb,
} from "@fortawesome/free-brands-svg-icons";

Vue.prototype.$Parse = Parse;

Vue.config.productionTip = false;

library.add(
  faUserSecret,
  faUser,
  faSearch,
  faChevronDown,
  faFacebookF,
  faTwitter,
  faApple,
  faGoogle,
  faInstagram,
  faPlus,
  faHeart,
  faCheckCircle,
  faCheck,
  faEye,
  faPlusCircle,
  faImdb,
  faShareAlt,
  faThumbsUp,
  faThumbsDown,
  faChevronRight,
  faChevronLeft,
  faTimes,
  faTimesCircle,
  faEnvelope,
  faLock,
  faBars,
  faFilm,
  faGlobe,
  faSpinner,
  faStar,
  faSignOutAlt
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("font-awesome-layers-text", FontAwesomeLayersText);

Vue.component(
  "IthTopBar",
  require("@/components/generics/topbar/IthTopBarComponent.vue").default
);
Vue.component(
  "IthAdMobileApp",
  require("@/components/generics/topbar/IthAdMobileAppComponent.vue").default
);
Vue.component(
  "IthAssideBar",
  require("@/components/generics/topbar/IthAssideBarComponent.vue").default
);
Vue.component(
  "IthSadBottom",
  require("@/components/generics/sad/IthBottomComponent.vue").default
);
Vue.component(
  "IthSadAsside",
  require("@/components/generics/sad/IthAssideComponent.vue").default
);
Vue.component(
  "IthSadTop",
  require("@/components/generics/sad/IthTopComponent.vue").default
);
Vue.component(
  "IthSadHome",
  require("@/components/generics/sad/IthHomeComponent.vue").default
);
Vue.component(
  "IthLeftAssideBar",
  require("@/components/generics/topbar/IthLeftAssideBarComponent.vue").default
);
Vue.component(
  "IthLanguage",
  require("@/components/generics/topbar/IthLanguageComponent.vue").default
);
Vue.component(
  "IthForgotPassword",
  require("@/components/generics/topbar/IthForgotPasswordComponent.vue").default
);
Vue.component(
  "IthRegisterUser",
  require("@/components/generics/topbar/IthRegisterUserComponent.vue").default
);
Vue.component(
  "IthSeachInput",
  require("@/components/generics/topbar/IthSeachInputComponent.vue").default
);
Vue.component(
  "IthLoginUser",
  require("@/components/generics/topbar/IthLoginUserComponent.vue").default
);

Vue.component(
  "IthAlert",
  require("@/components/generics/IthAlertComponent.vue").default
);
Vue.component(
  "IthNoResults",
  require("@/components/generics/IthNoResultsComponent.vue").default
);
Vue.component(
  "IthGridSkeleton",
  require("@/components/generics/skeletons/IthGridSkeletonComponent.vue")
    .default
);
Vue.component(
  "IthSkeleton",
  require("@/components/generics/skeletons/IthSkeletonComponent.vue").default
);
Vue.component(
  "IthPlatformSkeleton",
  require("@/components/generics/skeletons/IthPlatformSkeletonComponent.vue")
    .default
);
Vue.component(
  "IthGridBigSkeleton",
  require("@/components/generics/skeletons/IthGridBigSkeletonComponent.vue")
    .default
);
Vue.component(
  "IthGridPlatformSkeleton",
  require("@/components/generics/skeletons/IthGridPlatformSkeletonComponent.vue")
    .default
);
Vue.component(
  "IthDetailSkeleton",
  require("@/components/generics/skeletons/IthDetailSkeletonComponent.vue")
    .default
);
Vue.component(
  "IthDetailGeneralSkeleton",
  require("@/components/generics/skeletons/IthDetailGeneralSkeletonComponent.vue")
    .default
);

Vue.component(
  "IthBannerSearchPlatform",
  require("@/components/home/IthBannerSearchPlatformComponent.vue").default
);
Vue.component(
  "IthCardsWatch",
  require("@/components/home/IthCardsWatchComponent.vue").default
);
Vue.component(
  "IthSubmenuSort",
  require("@/components/generics/submenu/IthSubmenuSortComponent.vue").default
);
Vue.component(
  "IthSubmenuSortKids",
  require("@/components/generics/submenu/IthSubmenuSortKidsComponent.vue")
    .default
);
Vue.component(
  "IthSubmenuGenres",
  require("@/components/generics/submenu/IthSubmenuGenresComponent.vue").default
);
Vue.component(
  "IthSubmenuMonths",
  require("@/components/generics/submenu/IthSubmenuMonthsComponent.vue").default
);
Vue.component(
  "IthSubmenuImdb",
  require("@/components/generics/submenu/IthSubmenuImdbComponent.vue").default
);
Vue.component(
  "IthSubmenuLanguages",
  require("@/components/generics/submenu/IthSubmenuLanguagesComponent.vue")
    .default
);
Vue.component(
  "IthSubmenuLanguage",
  require("@/components/generics/submenu/IthSubmenuLanguageComponent.vue")
    .default
);
Vue.component(
  "IthSubmenuNewUpdates",
  require("@/components/platforms/IthSubmenuNewUpdatesComponent.vue").default
);
Vue.component(
  "IthSubmenu",
  require("@/components/home/IthSubmenuComponent.vue").default
);
Vue.component(
  "IthGridMovies",
  require("@/components/home/IthGridMoviesComponent.vue").default
);
Vue.component(
  "IthGridMoviesPlatform",
  require("@/components/platforms/IthGridMoviesPlatformComponent.vue").default
);
Vue.component(
  "IthMoviesGridUpdatesDetail",
  require("@/components/platforms/IthMoviesGridUpdatesDetailComponent.vue")
    .default
);
Vue.component(
  "IthTableReleasing",
  require("@/components/platforms/IthTableReleasingComponent.vue").default
);
Vue.component(
  "ithTableLatestReview",
  require("@/components/platforms/ithTableLatestReviewComponent.vue").default
);

Vue.component(
  "IthMoviesGridDetail",
  require("@/components/home/IthMoviesGridDetailComponent.vue").default
);
Vue.component(
  "IthSeriesGridDetail",
  require("@/components/home/IthSeriesGridDetailComponent.vue").default
);
Vue.component(
  "IthFooter",
  require("@/components/generics/footer/IthFooterComponent.vue").default
);
Vue.component(
  "IthDetailHeader",
  require("@/components/detail/IthDetailHeaderComponent.vue").default
);
Vue.component(
  "IthDetailAsside",
  require("@/components/detail/IthDetailAssideComponent.vue").default
);
Vue.component(
  "IthDetailSection",
  require("@/components/detail/IthDetailSectionComponent.vue").default
);
Vue.component(
  "IthDetailGeneral",
  require("@/components/detail/IthDetailGeneralComponent.vue").default
);
Vue.component(
  "IthDetailEpisodes",
  require("@/components/detail/IthDetailEpisodesComponent.vue").default
);
Vue.component(
  "IthDetailEpisodesDetail",
  require("@/components/detail/IthDetailEpisodesDetailComponent.vue").default
);
Vue.component(
  "IthModalEpisodes",
  require("@/components/detail/IthModalEpisodesComponent.vue").default
);
Vue.component(
  "IthDetailTrailers",
  require("@/components/detail/IthDetailTrailersComponent.vue").default
);
Vue.component(
  "IthDetailRecomendations",
  require("@/components/detail/IthDetailRecomendationsComponent.vue").default
);
Vue.component(
  "IthDetailComments",
  require("@/components/detail/IthDetailCommentsComponent.vue").default
);
Vue.component(
  "IthFormContact",
  require("@/components/generics/footer/IthFormContactComponent.vue").default
);
Vue.component(
  "IthFormFeedback",
  require("@/components/generics/footer/IthFormFeedbackComponent.vue").default
);
Vue.component(
  "IthPaginationBullets",
  require("@/components/generics/IthPaginationBulletsComponent.vue").default
);
Vue.component(
  "IthGridArticles",
  require("@/components/home/IthGridArticlesComponent.vue").default
);
Vue.component(
  "IthArticleComments",
  require("@/components/articles/IthArticleCommentsComponent.vue").default
);

Vue.component(
  "IthGridArticlesFull",
  require("@/components/articles/IthGridArticlesFullComponent.vue").default
);
Vue.component(
  "IthGridArticlesDetail",
  require("@/components/articles/IthGridArticlesDetailComponent.vue").default
);
Vue.component(
  "IthGridReviewDetail",
  require("@/components/articles/IthGridReviewDetailComponent.vue").default
);
Vue.component(
  "IthRating",
  require("@/components/articles/IthRatingComponent.vue").default
);

Vue.component(
  "IthTableOTTPlatforms",
  require("@/components/articles/IthTableOTTPlatformsComponent.vue").default
);
Vue.component(
  "IthSubmenuKids",
  require("@/components/kids/IthSubmenuKidsComponent.vue").default
);
Vue.component(
  "IthGridMoviesKids",
  require("@/components/kids/IthGridMoviesKidsComponent.vue").default
);
Vue.component(
  "IthGridMoviesKidsDetail",
  require("@/components/kids/IthGridMoviesKidsDetailComponent.vue").default
);
Vue.component(
  "IthGridSeriesKidsDetail",
  require("@/components/kids/IthGridSeriesKidsDetailComponent.vue").default
);
Vue.component(
  "IthBannerSearchKidsPlatform",
  require("@/components/kids/IthBannerSearchKidsPlatformComponent.vue").default
);
Vue.component(
  "IthWatchlistGrid",
  require("@/components/watchlist/IthWatchlistGridComponent.vue").default
);
Vue.component(
  "IthCardsWatchlist",
  require("@/components/watchlist/IthCardsWatchlistComponent.vue").default
);
Vue.component(
  "IthWatchlistGridDetail",
  require("@/components/watchlist/IthWatchlistGridDetailComponent.vue").default
);
Vue.component(
  "IthSubmenuMustWatch",
  require("@/components/mustwatch/IthSubmenuMustWatchComponent.vue").default
);
Vue.component(
  "IthMustWatchRecommendedLists",
  require("@/components/mustwatch/IthMustWatchRecommendedListsComponent.vue")
    .default
);
Vue.component(
  "IthMustWatchGrid",
  require("@/components/mustwatch/IthMustWatchGridComponent.vue").default
);
Vue.component(
  "IthMustWatchGridDetail",
  require("@/components/mustwatch/IthMustWatchGridDetailComponent.vue").default
);
Vue.component(
  "IthRecommendedCircleBar",
  require("@/components/recommended/IthRecommendedCircleBarComponent.vue")
    .default
);
Vue.component(
  "IthRecommendedGrid",
  require("@/components/recommended/IthRecommendedGridComponent.vue").default
);
Vue.component(
  "IthRecommendedGridDetail",
  require("@/components/recommended/IthRecommendedGridDetailComponent.vue")
    .default
);
Vue.component(
  "IthMustWatchQuiz",
  require("@/components/mustwatch/IthMustWatchQuizComponent.vue").default
);
Vue.component(
  "IthBanner",
  require("@/components/generics/IthBannerComponent.vue").default
);

Vue.component(
  "IthSeachInputPlatforms",
  require("@/components/generics/IthSeachInputPlatformsComponent.vue").default
);
Vue.component(
  "IthPrivacyArea",
  require("@/components/generics/IthPrivacyAreaComponent.vue").default
);

Vue.component(
  "IthAboutUs",
  require("@/components/generics/IthAboutUsComponent.vue").default
);
Vue.component(
  "IthTermsService",
  require("@/components/generics/IthTermsServiceComponent.vue").default
);
Vue.component(
  "IthTermsMobile",
  require("@/components/generics/IthTermsMobileComponent.vue").default
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
